<template>
  <div class="big">
    <ImportData
      :isFlag="importdata"
      @refreshList="getList"
    ></ImportData>
    <div class="page_title">医生拉新任务管理（业务员）</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>任务月份</span>
            <el-date-picker
              v-model="month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              style="margin-left: 6px; width: 140px"
              @change="search"
              clearable
            ></el-date-picker>
          </div>
          <div class="item">
            <span>员工号</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_code"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工姓名</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_name"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工手机号</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_phone"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981; margin-left: 6px"
              @click="search"
            >查询</el-button>
            <span style="margin: 0 10px 0 15px">是否达标</span>
            <el-radio-group
              v-model="is_stand"
              @change="search"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="pricebox">
          <div class="price">
            <div class="priceitem">
              <div
                class="num"
                style="color: #333"
              >{{ current_time }}</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ user_num }}</div>
              <div class="gray">员工人数</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ task_num }}</div>
              <div class="gray">总任务人数</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ auth_num }}</div>
              <div class="gray">认证通过人数</div>
            </div>
          </div>
          <span>
            <el-button
              type="primary"
              @click="addData"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('875') : false
        "
            >导入任务</el-button>
            <el-button
              @click="deldata=true;del_month=''"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('874') : false
        "
            >删除任务</el-button>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="员工号"
              prop="recommender_code"
            >
            </el-table-column>

            <el-table-column
              label="员工姓名"
              prop="recommender_name"
            >
            </el-table-column>
            <el-table-column
              label="员工手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="任务人数"
              prop="auth_doctor_num"
            ></el-table-column>
            <el-table-column
              label="本月注册人数"
              prop="doctor_count"
            ></el-table-column>
            <el-table-column
              label="本月认证通过人数"
              prop="auth_count"
            ></el-table-column>
            <el-table-column
              label="本月是否达标"
              prop="pay_money"
            >
              <template slot-scope="scope">

                <div v-if="scope.row.auth_count>=scope.row.auth_doctor_num">是</div>
                <div v-else>否</div>
              </template>

            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row.recommender_code)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('876') : false
              "
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="padding: 20px 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="请选择删除任务月份"
      :visible.sync="deldata"
      width="360px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div style="padding:30px 40px">
        <div>
          <span>任务月份</span>
          <el-date-picker
            v-model="del_month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style="margin-left: 6px;width: 200px"
            clearable
            @change="changeDelMonth"
          ></el-date-picker>
        </div>
        <div style="text-align:center;margin-top:40px">
          <el-button
            type="primary"
            size="mini"
            @click="delMonth"
          >确认</el-button>
          <el-button
            plain
            size="mini"
            @click="deldata=false"
          >取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import ImportData from './ImportData.vue';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      recommender_phone: '',
      recommender_code: '',
      recommender_name: '',
      month: '',
      is_stand: 0,
      current_time: '',
      importdata: false,
      deldata: false,
      del_month: '',
      user_num: 0,
      task_num: 0,
      auth_num: 0
    };
  },
  components: {
    ImportData
  },
  filters: {
    dateFormat(date) {
      return dayjs.unix(date).format('YYYY-MM');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      if (!this.month) {
        this.$message.error('请选择任务月份');
        return false;
      }
      this.current_time = dayjs(this.month).format('YYYY年MM月');
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        month: this.month,
        recommender_phone: this.recommender_phone,
        recommender_code: this.recommender_code,
        recommender_name: this.recommender_name,
        is_stand: this.is_stand
      };
      this.axios
        .post('platform/Activity/getRecommenderAssignmenList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.auth_count = item.auth_count ? item.auth_count : 0;
              item.doctor_count = item.doctor_count ? item.doctor_count : 0;
              return item;
            });
            this.user_num = res.data.user_num;
            this.task_num = res.data.task_num;
            this.auth_num = res.data.auth_num;
            this.totalNum = res.data.total;
          }
        });
    },
    //查看详情
    toDetail(recommender_code) {
      this.$router.push({
        path: 'salesmandetail',
        query: {
          recommender_code,
          month: this.month
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导入数据
    addData() {
      this.importdata = !this.importdata;
    },
    //删除改变月份
    changeDelMonth(month) {
      if (month) {
        this.axios
          .post('platform/Activity/recommenderAssignmentCount', { month })
          .then((res) => {
            if (res.code == 0) {
              if (res.data.info.count == 0) {
                this.$alert('该月任务不存在,请重新选择', '提示', {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    this.del_month = '';
                  }
                });
              }
            }
          });
      }
    },
    delMonth() {
      if (!this.del_month) {
        this.$message.error('请选择删除任务的月份');
        return false;
      }
      let month = this.del_month;
      this.axios
        .post('platform/Activity/delRecommenderAssignmen', { month })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.deldata = false;
            this.getList();
          }
        });
    }
  },
  activated() {
    if (this.$route.query.month) {
      this.month = this.$route.query.month;
    } else {
      this.month = dayjs(new Date()).format('YYYY-MM');
    }
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 14px;
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin-bottom: 12px;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      width: 200px;
      border-right: solid 1px #e1e3e9;
    }
    .priceitem:before {
      content: '';
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    color: #f24e33;
  }
}
</style>
